import BaseApiService from './api.base.service'

class AreaPubblicaApiService extends BaseApiService {
  constructor() {
    super('AreaPubblica')
  }
  getUserCF(id) {
    return this.callGet(`/GetUserCFByIdUtente`, { id: id })
  }

  getAreaTematicaList() {
    return this.callGet('/getAreaTematicaList')
  }

  getAreaList() {
    return this.callGet('/getAreaList')
  }

  getRegioneList() {
    return this.callGet('/getRegioneList')
  }

  // getTrainingCourseTypesList() {
  //   return this.callGet('/types/training')
  // }

  getAreaRiservataEnumList() {
    return this.callGet('/getAreaRiservataEnumList')
  }

  getELearningClassList(categoryId) {
    return this.callGet(`/getELearningClassList/`, { categoryId: categoryId })
  }

  getTaxStudiesCenterClassList() {
    return this.callGet(`/getTaxStudiesCenterClassList/`)
  }

  getDatiCorsoDirettaByCodiceProdotto(codiceProdotto) {
    return this.callGet('/getDatiCorsoDirettaByCodiceProdotto', {
      codiceProdotto: codiceProdotto,
    })
  }
}

// export const plantsApi = new SmartFactoryApiService('factory/plants')
export const areaPubblicaApi = new AreaPubblicaApiService()
